<template>
  <div v-if="coberturas">
    <Titulo :title="titulo" />
    <template v-if="contratadas">
      <div class="div_coberturas_label">
        <dl class="dl-coberturas-label" style="margin-top: 0px !important;">
          <template v-for="(cobertura, index) in coberturas.itens" :key="index">
            <div >
              <dt class="dt-coberturas-label">{{ cobertura.nome }}</dt>
              <dd class="dd-coberturas-label" :style="cobertura.cor">{{ formatMoeda(cobertura.valor, true) }}</dd>
                <p class="p-coberturas-label-separador" v-if="cobertura.itens && index < (cobertura.itens.length - 1)"></p>
            </div>
          </template>
        </dl>
      </div>
    </template>
    <template v-else>
      <div class="div_coberturas_label" style="margin-bottom: 30px;padding-left: 5px;">
        <p>Você ainda não contratou uma cobertura</p>
      </div>
    </template>
    {{ }}
    <MiniCardAcao v-if="statusParticipacao === 'Antigo'" :texto="textoMiniCard" :router="'/seguro'" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Titulo from './Titulo.vue'
import MiniCardAcao from './MiniCardAcao.vue'
const financeiro = require("../../functions/geral/Financeiro")

export default {
  components: {
    Titulo,
    MiniCardAcao
  },
  props: ["titulo", "contratadas", "contratacao_seg"],
  computed: {
  ...mapGetters({
      participante: "participante",
      plano: "plano",
      statusParticipacao: "statusParticipacao",
    }),
  },
  data() {
    return {
      contratacaoSeg: false,
      segmento: '',
      textoMiniCard:'',
      coberturas: null
    }
  },
  created() {
    
    console.log('this.participante',this.participante)
    if((this.participante.projetoVida || {}).coberturas) {
      this.coberturas = (this.participante.projetoVida || {}).coberturas 
      this.segmento = this.participante.segmento
      this.contratacaoSeg = this.contratacao_seg
      if(this.contratacaoSeg) {
        this.textoMiniCard = 'Acompanhe aqui seu pedido de nova cobertura'
      } else {
        let texto_padrao =  this.segmento.seg_coberturas.acao || 'Por que não uma cobertura de '
        this.textoMiniCard = `${texto_padrao} ${this.coberturas.acao.valor_cobertura_potencial}?`
      }
      this.preencherSegmento()
    }
  },
  methods: {
    preencherSegmento() {
      for(var i=0; i<this.coberturas.itens.length; i++) {
        this.coberturas.itens[i].cor = this.segmento.seg_coberturas.lista_itens_coberturas[i].cor
      }
    },
    formatMoeda(value, incluiCifrao) {
      if (value === 0) {
          return "(não contratado)"
      } else if (value && value !== 0) {
          let val = financeiro.valor_to_string_formatado(value, 2, incluiCifrao, true)
          return val
      }
    }
  }
}
</script>
